<script lang="ts">
    import CustomButton from "../Custom/CustomButton.svelte";
    import IconFa from "../Icon/IconFa.svelte";
    import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

    export let title: string = "Une erreur est survenue";
    export let actionLabel: string = "Réessayer";
    export let onAction: (() => void) | null = null;
</script>

<div class="error-screen">
    <div class="error-card">
        <h1>
            <IconFa icon={faTriangleExclamation} extraClass="mr-2" />Oups ...
        </h1>
        <h2>{title}</h2>
        {#if onAction}
            <CustomButton label={actionLabel} onClick={onAction} />
        {/if}
    </div>
</div>

<style>
    .error-screen {
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
    }

    .error-card {
        background: white;
        border-radius: 1rem;
        padding: 2rem;
        max-width: 800px;
        width: 90%;
        text-align: center;
        animation: fadeIn 0.25s ease;
        pointer-events: auto;
    }

    h1 {
        font-size: 1.4rem;
        font-weight: 500;
        color: var(--primary)
    }

    h2 {
        margin-top: 0.5rem;
        margin-bottom: 1.5rem;
        font-size: 1rem;
        font-weight: 300;
        color: #111827;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
